import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Table, Pagination } from 'react-bootstrap';
import APIserver from '../../../../api/axiosConfig';
import { Link } from 'react-router-dom';

const ReporteCompras = () => {
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [totalCompras, setTotalCompras] = useState(0);
    const [totalComprasPagado, setTotalComprasPagado] = useState(0);
    const [totalComprasPendiente, setTotalComprasPendiente] = useState(0);
    const [totalComprasVencida, setTotalCompraVencida] = useState(0);
    const [comprasPorProveedorEstadoData, setComprasPorProveedorEstadoData] = useState([]);
    const [comprasPorProveedorData, setComprasPorProveedorData] = useState([]);
    const [compras, setCompras] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0); // Estado para el total de registros

    useEffect(() => {
        const today = new Date();

        // Fecha de inicio del mes (primer día)
        const primerDiaMes = new Date(today.getFullYear(), today.getMonth(), 1);
        const fechaInicioMes = primerDiaMes.toISOString().split('T')[0]; // Formato YYYY-MM-DD

        // Fecha de fin del mes (último día)
        const ultimoDiaMes = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const fechaFinMes = ultimoDiaMes.toISOString().split('T')[0];

        setFechaInicio(fechaInicioMes);
        setFechaFin(fechaFinMes);
    }, []);

    useEffect(() => {
        const today = new Date();

        // Fecha de inicio del mes (primer día)
        const primerDiaMes = new Date(today.getFullYear(), today.getMonth(), 1);
        const fechaInicioMes = primerDiaMes.toISOString().split('T')[0]; // Formato YYYY-MM-DD

        // Fecha de fin del mes (último día)
        const ultimoDiaMes = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const fechaFinMes = ultimoDiaMes.toISOString().split('T')[0];

        setFechaInicio(fechaInicioMes);
        setFechaFin(fechaFinMes);
    }, []);

    // Función para cargar las compras desde el backend
    useEffect(() => {
        if (fechaInicio && fechaFin) { // Verifica que ambas fechas estén seleccionadas
            fetchCompras();
        }
    }, [rowsPerPage, currentPage, fechaInicio, fechaFin]); // Dependencias

    const fetchCompras = async () => {
        try {
            const response = await APIserver.get(`/api/reportesCompras/facturas-compras`, {
                params: {
                    fechaInicio,
                    fechaFin,
                    limit: rowsPerPage, // Número de registros por página
                    offset: (currentPage - 1) * rowsPerPage, // Desplazamiento calculado
                },
            });

            const { results, totalPages } = response.data; // Asegúrate de que el backend envíe `results` y `totalPages`
            setCompras(results); // Asignar los datos de facturas
            setTotalPages(totalPages); // Total de páginas desde el backend
        } catch (error) {
            console.error('Error al obtener las compras:', error);
        }
    };

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value));
        setCurrentPage(1);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page); // Actualizar la página actual
        fetchCompras(page, rowsPerPage); // Cargar los datos correspondientes a esa página
    };

    // Función para renderizar los botones de paginación
    const renderPaginationItems = () => {
        const items = [];
        const pageRangeDisplayed = 5; // Número de páginas visibles
        let startPage = Math.max(1, currentPage - Math.floor(pageRangeDisplayed / 2));
        let endPage = Math.min(totalPages, startPage + pageRangeDisplayed - 1);

        // Ajustamos si el rango de páginas es menor al rango visible
        if (endPage - startPage < pageRangeDisplayed - 1) {
            startPage = Math.max(1, endPage - pageRangeDisplayed + 1);
        }

        // Mostrar los botones de navegación
        if (startPage > 1) {
            items.push(
                <Pagination.First key="first" onClick={() => handlePageChange(1)} />
            );
        }

        if (currentPage > 1) {
            items.push(
                <Pagination.Prev key="prev" onClick={() => handlePageChange(currentPage - 1)} />
            );
        }

        // Mostrar las páginas dentro del rango visible
        for (let number = startPage; number <= endPage; number++) {
            if (number <= totalPages) {
                items.push(
                    <Pagination.Item
                        key={number}
                        active={number === currentPage}
                        onClick={() => handlePageChange(number)}
                    >
                        {number}
                    </Pagination.Item>
                );
            }
        }

        if (currentPage < totalPages) {
            items.push(
                <Pagination.Next key="next" onClick={() => handlePageChange(currentPage + 1)} />
            );
        }

        if (endPage < totalPages) {
            items.push(
                <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />
            );
        }

        return items;
    };

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0
        }).format(value);
    };

    // Llamada a la API para obtener los datos de las compras
    const fetchComprasData = async () => {
        try {
            const [comprasRes, comprasPagadoRes, comprasPendienteRes, comprasVencidaRes] = await Promise.all([
                APIserver.get('/api/reportesCompras/total-compras', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportesCompras/total-compras-pagado', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportesCompras/total-compras-pendiente', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportesCompras/total-compras-vencida', { params: { fechaInicio, fechaFin } }),

            ]);

            setTotalCompras(comprasRes.data || 0);
            setTotalComprasPagado(comprasPagadoRes.data || 0);
            setTotalComprasPendiente(comprasPendienteRes.data || 0);
            setTotalCompraVencida(comprasVencidaRes.data || 0);

        } catch (error) {
            console.error("Error fetching report data", error);
        }
    };

    useEffect(() => {
        if (fechaInicio && fechaFin) {
            fetchComprasData();
        }
    }, [fechaInicio, fechaFin]);

    // Efecto para obtener los datos de compras cuando el componente se monta
    useEffect(() => {
        fetchComprasData();
    }, []);

    // Función para exportar el archivo Excel
    const exportarExcel = async () => {
        try {
            // Verificar si las fechas son válidas
            if (!fechaInicio || !fechaFin) {
                alert('Por favor, seleccione un rango de fechas válido.');
                return;
            }

            const response = await APIserver.get('/api/reportesCompras/exportar-excel', {
                params: { fechaInicio, fechaFin },
                responseType: 'arraybuffer',  // Recibimos los datos como un buffer de archivo
            });

            // Crear un Blob con la respuesta para que el navegador lo interprete como un archivo
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            // Crear un enlace temporal para descargar el archivo
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Compras_${fechaInicio}_a_${fechaFin}.xlsx`; // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            link.remove();  // Elimina el enlace temporal después de hacer clic
        } catch (error) {
            console.error('Error al exportar el Excel:', error);
            alert('Hubo un error al generar el archivo Excel. Por favor, intente nuevamente.');
        }
    };

    // Función para formatear valores en COP
    const formatCOP = (value) => value?.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }) || '$0';

    // Función para formatear la fecha en formato DD/MM/YYYY
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses son de 0 a 11
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    };

    return (
        <Container fluid className="py-3">
            {/* Filtros de Reporte */}
            <div className='d-flex flex-column flex-md-row align-items-center align-items-md-end justify-content-center mb-3 text-center'>
                <div className='d-flex flex-column me-md-3 mb-3 mb-md-0'>
                    <Form.Label>Desde</Form.Label>
                    <Form.Control
                        type='date'
                        value={fechaInicio}
                        onChange={(e) => {
                            const selectedDate = e.target.value;
                            if (new Date(selectedDate) <= new Date(fechaFin || new Date())) {
                                setFechaInicio(selectedDate);
                            }
                        }}
                        max={new Date().toISOString().split('T')[0]} // Fecha máxima: Hoy
                        style={{ minWidth: '200px' }}
                    />
                </div>
                <div className='d-flex flex-column me-md-3 mb-3 mb-md-0'>
                    <Form.Label>Hasta</Form.Label>
                    <Form.Control
                        type='date'
                        value={fechaFin}
                        onChange={(e) => {
                            const selectedDate = e.target.value;
                            if (new Date(selectedDate) >= new Date(fechaInicio) && new Date(selectedDate) <= new Date()) {
                                setFechaFin(selectedDate);
                            }
                        }}
                        max={new Date().toISOString().split('T')[0]} // Fecha máxima: Hoy
                        style={{ minWidth: '200px' }}
                    />
                </div>
                <div className='d-flex align-items-center justify-content-end mt-3 mt-md-0'>
                    <Button variant='danger' onClick={exportarExcel}>
                        Exportar
                    </Button>
                </div>
            </div>

            {/* Resumen de Compras Totales */}
            <Row className="mb-4 text-center">
                <Col md={3}>
                    <Card bg='light' className='text-dark'>
                        <Card.Body>
                            <Card.Title>Total Compras ({totalCompras.totalFacturasCompras || 0})</Card.Title>
                            <h4>{formatCOP(totalCompras.totalCompras || 0)}</h4>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card bg='light' className='text-dark'>
                        <Card.Body>
                            <Card.Title>Total Pagado ({totalComprasPagado.totalFacturasComprasPagado || 0})</Card.Title>
                            <h4>{formatCOP(totalComprasPagado.totalComprasPagado || 0)}</h4>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card bg='light' className='text-dark'>
                        <Card.Body>
                            <Card.Title>Total Pendiente ({totalComprasPendiente.totalFacturasComprasPendiente || 0})</Card.Title>
                            <h4>{formatCOP(totalComprasPendiente.totalComprasPendiente || 0)}</h4>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card bg='light' className='text-dark'>
                        <Card.Body>
                            <Card.Title>Total Vencido ({totalComprasVencida.totalFacturasComprasVencida || 0})</Card.Title>
                            <h4>{formatCOP(totalComprasVencida.totalComprasVencida || 0)}</h4>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <div style={{ boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)" }}>
                <Table responsive className='text-center align-middle border'>
                    <thead>
                        <tr>
                            <th colSpan={7}>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <Form.Select
                                            className='ms-2'
                                            value={rowsPerPage}
                                            onChange={handleChangeRowsPerPage}
                                        >
                                            <option value='5'>5</option>
                                            <option value='10'>10</option>
                                            <option value='20'>20</option>
                                            <option value='50'>50</option>
                                        </Form.Select>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th>Factura</th>
                            <th>Proveedor</th>
                            <th>Creacion</th>
                            <th>Total</th>
                            <th>Pagado</th>
                            <th>Pendiente</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {compras.map((compra) => (
                            <tr key={compra.idCompra}>
                                <td>
                                    <Link to={`/admin/Compras/DetallesCompra/${compra.idCompra}/`} className='text-decoration-none'>
                                        {compra.numCompra}
                                    </Link>
                                </td>
                                <td>
                                    <Link to={`/admin/Proveedores/DetallesProveedores/${compra.idProveedor}/`} className='text-decoration-none'>
                                        {compra.nombreProveedor}
                                    </Link>
                                </td>
                                <td>{formatDate(compra.creacion)}</td>
                                <td>{formatCurrency(compra.totalCompra)}</td>
                                <td>{formatCurrency(compra.pagado)}</td>
                                <td>{formatCurrency(compra.pendiente)}</td>
                                <td className={`text-${compra.estado === 'pagada' ? 'success' : compra.estado === 'vencida' ? 'danger' : 'warning'}`}>
                                    {compra.estado === 'pagada' ? 'Pagada' : compra.estado === 'vencida' ? <span style={{ color: 'red' }}>Vencida</span> : 'Pendiente'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={7}>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <Pagination>
                                        {renderPaginationItems()}
                                    </Pagination>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </Container>
    );
};

export default ReporteCompras;
